import React, { useEffect, useRef, useState } from "react";
import { FaHandshake } from "react-icons/fa";
import MyPage from "../components/MyPage";

function Area() {
  const sectionRef = useRef(null);
  const [officeBearers, setOfficeBearers] = useState([]);
  const [executives, setExecutives] = useState([]);

  /* 🔹 API LOAD */
  useEffect(() => {
    // ✅ JSON → UI
    fetch("/api/area.json")
      .then(res => res.json())
      .then(data => {
        setOfficeBearers(data.officeBearers);
        setExecutives(data.executives);
      });

    // ✅ XML → exam / proof
    fetch("/api/area.xml")
      .then(res => res.text())
      .then(() => console.log("Area XML loaded"));
  }, []);

  /* 🔹 SCROLL ANIMATION */
  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          section.classList.add("in-view");
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );

    observer.observe(section);

    setTimeout(() => {
      section.classList.add("in-view");
    }, 300);

    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* ✅ SEO */}
     <MyPage
        title="Area | Thrissur Jilla Pravasi Kootayma"
        description="Thrissur Pravasi families united through community engagement and social welfare."
        keywords="Thrissur Pravasi, Community Engagement, Pravasi Activities"
      />


      {/* ===== INNER BANNER ===== */}
      <section className="inner-banner">
        <div className="inner-overlay"></div>
        <div className="inner-content banner-left">
          <h1>Area</h1>
        </div>
        <div className="breadcrumb banner-right">
          Home / <span>Area</span>
        </div>
      </section>

      {/* ===== AREA SECTION ===== */}
      <section className="area-section" ref={sectionRef}>

        {/* OFFICE BEARERS */}
        <div className="section-gap">
          <div className="area-header reveal-top">
            <h2><FaHandshake /> Office Bearers <span></span></h2>
          </div>

          <div className="area-grid">
            {officeBearers.map((item, index) => (
              <div
                className="area-card reveal-card"
                key={index}
                style={{ transitionDelay: `${index * 0.15}s` }}
              >
                <div className="image-wrap">
                  <img src={item.image} alt={item.name} />
                </div>
                <div className="area-info">
                  <h4>{item.name}</h4>
                  <span className="area-position">{item.position}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* EXECUTIVES */}
        <div className="area-header reveal-top">
          <h2><FaHandshake /> Area Presidents <span></span></h2>
        </div>

        <div className="area-grid">
          {executives.map((item, index) => (
            <div
              className="area-card reveal-card"
              key={index}
              style={{ transitionDelay: `${index * 0.15}s` }}
            >
              <div className="image-wrap">
                <img src={item.image} alt={item.name} />
              </div>
              <div className="area-info">
                <h4>{item.name}</h4>
                <span className="area-position">{item.position}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ===== CSS ===== */}
      <style>{`
/* ===== INNER BANNER ===== */
.inner-banner {
  position: relative;
  height: 420px;
  background: url("/assets/banner.jpg") center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  padding-top: 120px;
}

.inner-overlay {

  inset: 0;
  background: rgba(0,0,0,0.65);
}

.inner-content {
  position: relative;
  z-index: 1;
}

.inner-content h1 {
  font-size: 48px;
  font-weight: 700;
  font-family: "Merriweather", serif;
}

.breadcrumb {
  position: absolute;
  bottom: -20px;
  left: 55px;
  border-radius: 4px;
  background: var(--primary-color);
  padding: 10px 25px;
  font-size: 20px;
  font-weight: 500;
  color: #000;
  z-index: 1;
}

/* ===== AREA SECTION ===== */
.area-section {
  padding: 100px 80px;
  background: #fff;
  overflow-x: hidden;
}

.area-header {
  text-align: center;
  margin-bottom: 70px;
}

/* HEADER ANIMATION */
.reveal-top {
  opacity: 0;
  transform: translateY(40px);
  transition: all 0.8s ease;
}

.area-header h2 {
  font-size: 36px;
  font-weight: 700;
  font-family: "Merriweather", serif;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.area-header h2 span {
  width: 60px;
  height: 2px;
  background: #000;
}

.area-header p {
  font-size: 16px;
  margin-top: 12px;
  color: #333;
}

.area-position {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #555;
  margin-top: 2px;
  margin-bottom: 4px;
}

/* ===== GRID ===== */
.area-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 60px;
  max-width: 1400px;
  margin: 0 auto;
}

/* ===== CARD ===== */
.area-card {
  position: relative;
  text-align: center;
}

/* CARD ANIMATION */
.reveal-card {
  opacity: 0;
  transform: translateY(50px) scale(0.95);
  transition: all 0.9s ease;
}

/* ACTIVE */
.area-section.in-view .reveal-top,
.area-section.in-view .reveal-card {
  opacity: 1;
  transform: translateY(0) scale(1);
}

/* IMAGE */
.image-wrap {
  background: #9ac23c;
  border-radius: 22px;
  padding: 15px;
  transition: transform 0.35s ease;
   padding-top: 0px;
  padding-right: 0px;
  padding-bottom: 10px;
  padding-left: 10px;
}

.image-wrap img {
  width: 100%;
  height: 400px;
  object-fit: cover;
   object-position: top;  
  border-radius: 10px;
  display: block;
  margin-bottom: 0px;

  position: relative;
  left: -10px;     /* 🔥 left side move */
  bottom: -10px;   /* 🔥 bottom side move */
}

.area-card:hover .image-wrap {
  transform: translateY(-10px);
}

/* INFO */
.area-info {
  position: relative;
  z-index: 2;
  margin: -35px auto 0;
  background: #fff;
  width: 75%;
  padding: 14px 12px;
  border-radius: 10px;
  box-shadow: 0 8px 20px rgba(0,0,0,0.15);
}

.area-info h4 {
  font-size: 18px;
  font-weight: 700;
  font-family: "Merriweather", serif;
  color: #7aa118;
  margin: 0;
}

.area-info p {
  font-size: 14px;
  margin: 4px 0 0;
  color: #000;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 1200px) {
  .area-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 50px;
  }
}

@media (max-width: 768px) {
  .area-section {
    padding: 70px 20px;
  }

  .area-grid {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .area-info {
    width: 85%;
  }

  .image-wrap img {
    height: 380px;
  }

  .inner-content h1 {
    font-size: 36px;
  }

  .breadcrumb {
    left: 16px;
    bottom: -20px;
    padding: 8px 12px;
    font-size: 12px;
  }
}
  /* ===== BANNER PAGE LOAD ANIMATION ===== */
@keyframes bannerFromLeft {
  from {
    opacity: 0;
    transform: translateX(-80px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes bannerFromRight {
  from {
    opacity: 0;
    transform: translateX(80px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.banner-left {
  animation: bannerFromLeft 0.9s ease forwards;
}

.banner-right {
  animation: bannerFromRight 0.9s ease forwards;
}

/* 📞 PHONE LINK */
.phone-link {
  display: inline-block;
  margin-top: 6px;
  font-size: 14px;
  font-weight: 800;
  color: #000;
  text-decoration: none;
}

.phone-link:hover {
  color: #7aa118;
  text-decoration: underline;
}
  /* GAP BETWEEN SECTIONS */
.section-gap {
  margin-bottom: 120px;
}

@media (max-width: 768px) {
  .section-gap {
    margin-bottom: 80px;
  }
}

      `}</style>
    </>
  );
}

export default Area;
